import { render, staticRenderFns } from "./sso-select-client.vue?vue&type=template&id=2ac0496f&"
import script from "./sso-select-client.vue?vue&type=script&lang=js&"
export * from "./sso-select-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports